<label class="file-upload-button">
    <input data-test="file-upload-input" type="file" multiple [accept]="accept" (change)="onFileSelect($event)">
    <span class="file-upload-button__control">
        <vwui-icon iconName="vwui-add"></vwui-icon>
    </span>
</label>
